var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4313_3614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0983 12.8896V11.7015C10.0983 11.0714 9.84793 10.467 9.40233 10.0214C8.95673 9.57581 8.35237 9.32547 7.7222 9.32547H2.97006C2.33989 9.32547 1.73553 9.57581 1.28993 10.0214C0.844329 10.467 0.593994 11.0714 0.593994 11.7015V12.8896M13.6624 12.8896V11.7015C13.662 11.1751 13.4868 10.6637 13.1642 10.2476C12.8417 9.83149 12.3901 9.53431 11.8803 9.40269M9.50425 2.27449C10.0154 2.40535 10.4684 2.7026 10.7919 3.11936C11.1154 3.53613 11.291 4.04872 11.291 4.5763C11.291 5.10389 11.1154 5.61648 10.7919 6.03324C10.4684 6.45001 10.0154 6.74726 9.50425 6.87812M7.7222 4.57333C7.7222 5.8856 6.6584 6.9494 5.34613 6.9494C4.03386 6.9494 2.97006 5.8856 2.97006 4.57333C2.97006 3.26107 4.03386 2.19727 5.34613 2.19727C6.6584 2.19727 7.7222 3.26107 7.7222 4.57333Z",
    stroke: "white",
    strokeWidth: 1.42564,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4313_3614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.2564,
    height: 14.2564,
    fill: "white",
    transform: "translate(0 0.414062)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.439bfb68442c9bed16d96410bc0a3911.svg";
export { ForwardRef as ReactComponent };